import $ from "jquery";
import _ from "lodash";
import scroll from "../../util/scroll";

const fixedHeaderClass = "main-header--fixed";
const fixedSidebarClass = "page__sidebar--fixed";

const $body = $("body");
const mainHeaderHeight = $(".main-header").outerHeight();

const $sidebar = $(".page .page__sidebar");
const hasSidebar = $sidebar.find(".sub-nav").length > 0;

/**
 * When scrolling, check if scrolling up and we're far enough down on the page
 * to toggle on fixed header...and do so if needed. Turn off if scrolling down.
 * Debounced for perf
 *
 * @param  {event} event
 */
const onScroll = _.debounce((event) => {
  const direction = scroll.getDirection(event);
  if (direction !== scroll.SCROLL_DOWN && direction !== scroll.SCROLL_UP) {
    return; // we only care about vertical scrolling for now.
  }
  if ($body.hasClass("modal--visible")) {
    return; // don't do any of this with a modal showing.
  }
  scrollFx._toggleFixedHeader(direction);
  scrollFx._toggleFixedSidebar(direction);
}, 100);

var scrollFx = {
  _toggleSidebarPos: null,

  /**
   * We'll stick the class on the body because this affects other elements.
   * @param  {string} direction
   */
  _toggleFixedHeader(direction) {
    const hasFixedClass = $body.hasClass(fixedHeaderClass);
    if (direction == scroll.SCROLL_UP) {
      const scrollTop = $(window).scrollTop();
      $body.toggleClass(fixedHeaderClass, scrollTop > mainHeaderHeight);
    } else if (hasFixedClass) {
      $body.removeClass(fixedHeaderClass);
    }
  },

  /**
   * @param  {string} direction
   */
  _toggleFixedSidebar(direction) {
    if (!this.toggleSidebarPos) {
      return;
    }

    const scrollTop = $(window).scrollTop();
    $sidebar.toggleClass(fixedSidebarClass, scrollTop > this.toggleSidebarPos);
  },

  /**
   * Set the scrollY position at which we'll toggle the fixed sidebar.
   */
  _setToggleSidebarPos() {
    const $sidebarNav = $sidebar.find(".sub-nav");
    this.toggleSidebarPos =
      $sidebarNav.outerHeight() + $sidebarNav.offset().top;
  },

  /**
   * Init module
   */
  init() {
    $(window).on("wheel DOMMouseScroll", onScroll);

    if (hasSidebar) {
      this._setToggleSidebarPos();
      this._toggleFixedSidebar();
    }
  },
};

export default scrollFx;
